<div class="modal-body">
  <ebs-login (loginSuccess)="catchLoginSuccess($event)" [isAModalLogin]="isAModalLogin"></ebs-login>
</div>